import {
  MESSAGE_OF_THE_DAY_MLB_TITLE,
  MESSAGE_OF_THE_DAY_MLB_SUBTITLE,
  MESSAGE_OF_THE_DAY_MLB_CTA,
  MESSAGE_OF_THE_DAY_NFL_TITLE,
  MESSAGE_OF_THE_DAY_NFL_SUBTITLE,
  MESSAGE_OF_THE_DAY_NFL_CTA,
} from '../../../constants/localizations/messageOfTheDay';

export const themeConstants = {
  mlb: {
    titleKey: MESSAGE_OF_THE_DAY_MLB_TITLE,
    subtitleKey: MESSAGE_OF_THE_DAY_MLB_SUBTITLE,
    callToActionKey: MESSAGE_OF_THE_DAY_MLB_CTA,
    backgroundImageUrl: '/assets/img/messageOfTheDay/mlb.jpg',
  },
  nfl: {
    titleKey: MESSAGE_OF_THE_DAY_NFL_TITLE,
    subtitleKey: MESSAGE_OF_THE_DAY_NFL_SUBTITLE,
    callToActionKey: MESSAGE_OF_THE_DAY_NFL_CTA,
    backgroundImageUrl: '/assets/img/messageOfTheDay/nfl.jpg',
  },
};

// NOTE: [TUNE-13860] we're hard-coding this label value for now until MessageOfTheDay can be configured dynamically
export const labelValues = {
  interestSelectionDialog: 'dialogs/interestSelection',
};

export const errorValues = {
  missingCategoryId: 'missing-category-id',
  unsupportedCategoryId: 'unsupported-category-id',
};
